import { useEffect, useState } from "react";

import { AiFillSetting } from "react-icons/ai";
import {
  ButtonIcon,
  TextInputField,
  LoadingDiv,
  ButtonFlat,
  toName,
} from "../components";
import {
  MdAdd,
  MdModeEditOutline,
  MdOutlineCancel,
} from "react-icons/md";
import { BiSave } from "react-icons/bi";
import axios from "axios";
import { BASE_SERVER_URL } from "../sampleData";
import { PopUpAlert } from "../components/movableDragDropArea";
import FlowersList from "../widgets/settings/FlowersList";
import { TaggedList } from "../components/TaggedList";
import AddOnTypes from "../widgets/settings/AddOnTypes";
import PrinterConnection from "../widgets/settings/PrinterConnection";
import { toast } from "react-toastify";
import { useAuth } from "../auth/AuthContext";

export function SetupPage(props) {
  const [activeTab, setActiveTab] = useState(0);
  // settings:read gets you this screen; settings:manage is what lets you
  // change anything on it. Staff have the first and not the second.
  const canManage = (useAuth() || {}).can?.("settings:manage");

  const navList = [
    { title: "General", icon: <AiFillSetting className="icon mid" /> },
    { title: "Printer Connection", icon: <AiFillSetting className="icon mid" /> },
  ];

  function renderActiveTab() {
    if (activeTab === 0) return <GeneralSettings canManage={canManage} />;
    if (activeTab === 1)
      return (
        <div style={{ width: "85%", zIndex: "0" }} className="row margin-0 font-medium relative">
          <PrinterConnection />
        </div>
      );
    return (
      <div style={{ width: "85%", zIndex: "0" }} className="row margin-0 font-medium relative">
        <div className="col-md-12 col-sm-12 block">
          <header className="golden-card">{navList[activeTab]?.title || "Settings"}</header>
          <div className="width-100 center-hor padding-20">Coming soon.</div>
        </div>
      </div>
    );
  }

  return (
    <div className="data-input">
      <header className="">Application Settings</header>
      {!canManage && (
        <div
          className="width-100 text-center font-small"
          style={{ padding: "6px", background: "#f5efe0", color: "#7a5c1e" }}
        >
          You have read-only access to settings.
        </div>
      )}

      <div className="width-100 work-order-list height-stretch-container">
        <VerticalNavication navList={navList} active={activeTab} onChange={setActiveTab} />
        {renderActiveTab()}
      </div>
    </div>
  );
}

function VerticalNavication(props) {
  const navList = props.navList || [];
  const active = props.active || 0;
  return (
    <div
      className="ver-nav xlight-box-shadow font-medium"
      style={{ width: "15%" }}
    >
      {navList.map((each, index) => {
        return (
          <span
            key={index}
            onClick={() => {
              props.onChange && props.onChange(index);
            }}
            className={
              (index === active ? "selected" : "") + " center-hor justify-start"
            }
          >
            {/* {each.icon} */}
            {each.title || each}
          </span>
        );
      })}
    </div>
  );
}

function GeneralSettings(props) {
  const [loading, setLoading] = useState(false);
  const [setting, setSetting] = useState({});
  const [alert, setAlert] = useState({});
  const [types, setTypes] = useState([]);
  const [CCtypes, setCCtypes] = useState([]);
  const [pedestalTypes, setPedestalTypes] = useState([]);
  const [easelTypes, setEaselTypes] = useState([]);
  const [newProductType, setNewProductType] = useState("");

  const [editCCTypes, setEditCCTypes] = useState(false);
  const [editPedestalTypes, setEditPedestalTypes] = useState(false);
  const [editEaselTypes, setEditEaselTypes] = useState(false);

  useEffect(() => {
    let url = BASE_SERVER_URL + "/settings/getAll";
    setLoading(true);
    axios.get(url).then((doc) => {
      setLoading(false);
      if (doc.data.status === "success") {
        setSetting(doc.data.response[0] || {});
        setTypes(JSON.parse(doc.data.response[0].product_types || "[]"));
        setCCtypes(JSON.parse(doc.data.response[0].cc_types || "[]"));
        setPedestalTypes(JSON.parse(doc.data.response[0].pedestal_types || "[]"));
        setEaselTypes(JSON.parse(doc.data.response[0].easel_types || "[]"));
      }
    });
  }, []);

  function editSetting(data, callBack) {
    if (!props.canManage) {
      toast.warn("You don't have permission to change settings.");
      return;
    }
    let url = BASE_SERVER_URL + "/settings/update";
    axios
      .post(url, data)
      .then((doc) => {
        if (doc.data.status === "success") {
          setSetting(doc.data.response);
        } else {
          setAlert({
            type: "error",
            title: "Error Modifing Settings Data",
            message: doc.data.status,
          });
        }
      })
      .catch((err) => {
        setAlert({
          type: "error",
          title: "Error Modifing Settings Data",
          message: err.message,
        });
      })
      .finally(() => {
        callBack();
      });
  }

  function isValidSashPrice(inputString) {
    const numbersArray = inputString.split(",");
    for (const numberStr of numbersArray) {
      if (isNaN(parseFloat(numberStr)) || isNaN(Number(numberStr))) {
        return false;
      }
    }
    return true;
  }

  return (
    <div style={{ width: "85%", zIndex:"0" }} className="row margin-0 font-medium relative">
      {Object.keys(alert).length > 0 && (
        <PopUpAlert
          info={alert}
          onClose={() => {
            setAlert({});
          }}
        />
      )}
          
      {loading ? (
        <div className="col-md-4 col-sm-12">
          <header className="golden-card">Fees and Prices</header>
          <LoadingDiv amount={5} noDelay={true} height="35px" />
        </div>
      ) : (
        <div className="col-md-4 col-sm-12 block">
          <header className="golden-card">Fees and Prices</header>
          <div className="width-100 center-hor margin-10">
            <span className="width-75">GST</span>
            <span className="width-25">
              <EditableText
                value={Number(setting.gst) || 0}
                stringCallBack={(a) => {
                  return <span className="bold-1">{a.toFixed(2)}%</span>;
                }}
                placeHolder="GST"
                actionButtonAction={(a, callBack) => {
                  editSetting({ gst: a }, callBack);
                }}
                onChange={(a) => {
                  setSetting((prev) => {
                    let obj = { ...prev };
                    return { ...obj, gst: a };
                  });
                }}
              />
            </span>
          </div>
          <div className="width-100 center-hor margin-10">
            <span className="width-50 center-ver-col">
              <span className="width-100"> Delivery Fee </span>
              <span className="italic font-small color-red width-100">
                Numbers separated by comma
              </span>
            </span>
            <span className="width-50">
              <EditableText
                formatText={true}
                textFormatChecker={isValidSashPrice}
                stringCallBack={(a) => {
                  return a.split(",").map((each) => {
                    return <span>${Number(each || 0).toFixed(2)}</span>;
                  });
                }}
                value={setting.delivery_fee || ""}
                placeHolder="Delivery Fees (eg. 8.5, 12.00, 23.20)"
                actionButtonAction={(a, callBack) => {
                  if (isValidSashPrice(a)) {
                    editSetting({ delivery_fee: a }, callBack);
                  } else {
                    callBack();
                    setAlert({
                      title: "Incorrect Listing Format",
                      message: "Please input number list separated by commas",
                      type: "error",
                    });
                  }
                }}
                onChange={(a) => {
                  if (
                    !isValidSashPrice(a) &&
                    a[a.length - 1] !== "," &&
                    a[a.length - 1] !== " "
                  ) {
                    return false;
                  }
                  setSetting((prev) => {
                    let obj = { ...prev };
                    return { ...obj, delivery_fee: a };
                  });
                }}
              />
            </span>
          </div>
          <div className="width-100 center-hor margin-10">
            <span className="width-50 center-ver-col">
              <span className="width-100">Sash Prices</span>
              <span className="italic font-small color-red width-100">
                Numbers separated by comma
              </span>
            </span>
            <span className="width-50">
              <EditableText
                formatText={true}
                textFormatChecker={isValidSashPrice}
                stringCallBack={(a) => {
                  return a.split(",").map((each) => {
                    return <span>${Number(each || 0).toFixed(2)}</span>;
                  });
                }}
                value={setting.sash_prices || ""}
                placeHolder="Sash Prices (eg. 8.5, 12.00, 23.20)"
                actionButtonAction={(a, callBack) => {
                  if (isValidSashPrice(a)) {
                    editSetting({ sash_prices: a }, callBack);
                  } else {
                    callBack();
                    setAlert({
                      title: "Incorrect Listing Format",
                      message: "Please input number list separated by commas",
                      type: "error",
                    });
                  }
                }}
                onChange={(a) => {
                  if (
                    !isValidSashPrice(a) &&
                    a[a.length - 1] !== "," &&
                    a[a.length - 1] !== " "
                  ) {
                    return false;
                  }
                  setSetting((prev) => {
                    let obj = { ...prev };
                    return { ...obj, sash_prices: a };
                  });
                }}
              />
            </span>
          </div>
       <div className={editPedestalTypes || editEaselTypes ? "pop-overlay left" : ""}>
          <header className="golden-card" style={{ marginTop: "50px" }}>
            Product Types
          </header>
          <div className="width-100 center-hor">
            <div className="width-90">
              <TextInputField
                addClass="width-100 height-thin flat "
                addInputClass="light-border"
                placeHolder={"Add New Product Type..."}
                name="types"
                style={{ height: "30px !important" }}
                value={newProductType}
                noLable={true}
                onChageSetter={(a) => {
                  setNewProductType(a.value);
                }}
              />
            </div>
            <div className="width-10">
              <ButtonFlat
                addClass="width-100 thin-flat light-border"
                value="Add"
                style={{
                  height: "45px !important",
                  marginTop: "3px",
                  boxShadow: "0px 3px 8px rgba(142, 139, 139, 0.1) !important",
                }}
                clickTo={() => {
                  if (!Boolean(newProductType)) {
                    return false;
                  }

                  editSetting(
                    {
                      product_types: JSON.stringify([
                        ...types,
                        toName(newProductType),
                      ]),
                    },
                    function () {
                      setNewProductType("");
                      setTypes((prev) => {
                        return [...prev, toName(newProductType)];
                      });
                    }
                  );
                }}
              />
            </div>
            </div>
          <div className="row width-100" style={{}}>
            {(types || []).sort().map((each, index) => {
              const typeName = editCCTypes ? "cc_types" : editPedestalTypes ? "pedestal_types" : "easel_types";
              return (
                <div className="col-md-6">
                  <TaggedList
                    text={each}
                    editCCTypes={editCCTypes || editPedestalTypes || editEaselTypes}
                    onTagClick={() => {
                      if (
                        (!CCtypes.includes(each) && editCCTypes) || 
                        (!pedestalTypes.includes(each) && editPedestalTypes) || 
                        (!easelTypes.includes(each) && editEaselTypes)
                      ) {
                        editSetting(
                          { [typeName]: JSON.stringify([...(typeName === "cc_types" ? CCtypes : typeName === "pedestal_types" ? pedestalTypes : easelTypes), each]) },
                          function () {
                            if(editCCTypes) {
                              setCCtypes([...CCtypes, each]);
                            } else if(editPedestalTypes) {
                              setPedestalTypes([...pedestalTypes, each]);
                            } else {
                              setEaselTypes([...easelTypes, each]);
                            }
                          }
                        );
                      }
                    }}
                    remove={() => {
                      editSetting(
                        {
                          product_types: JSON.stringify(
                            types.filter((e, i) => {
                              return i !== index;
                            })
                          ),
                        },
                        function () {
                          setTypes((prev) => {
                            return prev.filter((e, i) => {
                              return i !== index;
                            });
                          });
                        }
                      );
                    }}
                  />
                </div>
              );
            })}
          </div>
        </div>
        </div>
      )}
      {loading ? (
        <div className="col-md-4 col-sm-12">
          <header className="golden-card">Casket Cover Categories</header>
          <LoadingDiv amount={5} noDelay={true} height="35px" />
        </div>
      ) : (
        <div className="col-md-4 col-sm-12 block">
          <header className="golden-card relative">
            Casket Cover Categories
            <div style={{ width: "50px", top: "2px" }} className="float-right">
              {editCCTypes ? (
                <MdOutlineCancel
                  className="icon mid"
                  onClick={() => {
                    setEditCCTypes(false);
                  }}
                />
              ) : (
                <MdAdd
                  className="icon mid"
                  onClick={() => {
                    setEditCCTypes(true);
                  }}
                />
              )}
            </div>
          </header>
          <div className="row width-100" style={{}}>
            {(CCtypes || []).sort().map((each, index) => {
              return (
                <div className="col-md-6">
                  <TaggedList
                    text={each}
                    remove={() => {
                      editSetting(
                        {
                          cc_types: JSON.stringify(
                            CCtypes.filter((e, i) => {
                              return i !== index;
                            })
                          ),
                        },
                        function () {
                          setCCtypes((prev) => {
                            return prev.filter((e, i) => {
                              return i !== index;
                            });
                          });
                        }
                      );
                    }}
                  />
                </div>
              );
            })}
          </div>
        <div className={editPedestalTypes ? "pop-overlay right" : ""}>
        <div className="width-100">
          <AddOnTypes 
              editSetting={editSetting}
              editTypes={editPedestalTypes} 
              setEditTypes={(val)=>{setEditPedestalTypes(val); setEditEaselTypes(false)}} 
              setTypes={setPedestalTypes} 
              types={pedestalTypes} 
          />
        </div>
        </div>
        <div className={editEaselTypes ? "pop-overlay right" : ""}>
        <div className="width-100">
          <AddOnTypes 
              editSetting={editSetting}
              easel={true}
              editTypes={editEaselTypes} 
              setEditTypes={(val)=>{setEditEaselTypes(val); setEditPedestalTypes(false)}} 
              setTypes={setEaselTypes} 
              types={easelTypes} 
          />
        </div>
        </div>
        </div>
      )}
      {loading ? (
        <div className="col-md-4 col-sm-12">
          <header className="golden-card">Content Flowers</header>
          <LoadingDiv amount={5} noDelay={true} height="35px" />
        </div>
      ) : (
        <FlowersList />
      )}
    </div>
  );
  
}


function EditableText(props) {
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);

  return edit ? (
    <TextInputField
      formatText={props.formatText}
      actionButtonAction={(a) => {
        setLoading(true);
        props.actionButtonAction(a, () => {
          setLoading(false);
          setEdit(false);
        });
      }}
      actionButton={true}
      actionButtonClass="flat2-btn float-absolute-right border-none"
      value={props.value}
      textFormatChecker={(a) => {
        return props.textFormatChecker(a);
      }}
      actionButtonValue={
        <ButtonIcon
          addClass="small"
          loading={loading}
          icon={<BiSave onClick={() => {}} className="icon mid" />}
        />
      }
      addClass="flat2"
      onChageSetter={(a) => {
        props.onChange(a.value);
      }}
    />
  ) : (
    <span className="text-list justify-end width-100 center-hor relative">
      {props.stringCallBack(props.value)}
      <div
        style={{
          width: "20px",
          position: "absolute",
          right: "-2px",
          top: "-15px",
        }}
      >
        <MdModeEditOutline
          onClick={() => {
            setEdit(true);
          }}
          className="icon small"
        />
      </div>
    </span>
  );
}